import { Item } from "types/common";

function getUniqueUomValues(data: Item[]) {
  const uomValues = data.map((item) => item.uom);
  const uniqueUomSet = new Set(uomValues);
  const uniqueUomArray = [...uniqueUomSet];
  return uniqueUomArray;
}

export default getUniqueUomValues;